import { useEffect } from "react";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import { Lightbox } from "@/components/ui/lightbox";

export function ReviewLightbox({
  open,
  onOpenChange,
  src,
  alt,
  canPrev,
  canNext,
  onPrev,
  onNext,
  rotation,
  onRotationChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string | null;
  alt: string;
  canPrev: boolean;
  canNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  /** Persisted rotation (degrees) for the currently shown page. */
  rotation?: number;
  onRotationChange?: (rotation: number) => void;
}) {
  useEffect(() => {
    if (!open) return;
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "ArrowLeft") onPrev();
      else if (e.key === "ArrowRight") onNext();
      else if (e.key === "Escape") onOpenChange(false);
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onPrev, onNext, onOpenChange]);

  return (
    <Lightbox
      open={open}
      onOpenChange={onOpenChange}
      src={src}
      alt={alt}
      rotation={rotation}
      onRotationChange={onRotationChange}
      action={
        <div className="flex gap-2">
          <button
            type="button"
            aria-label="Previous page"
            disabled={!canPrev}
            onClick={onPrev}
            className="flex size-11 items-center justify-center rounded-full bg-black/60 text-white disabled:opacity-30 active:scale-95"
          >
            <LuChevronLeft className="size-5" />
          </button>
          <button
            type="button"
            aria-label="Next page"
            disabled={!canNext}
            onClick={onNext}
            className="flex size-11 items-center justify-center rounded-full bg-black/60 text-white disabled:opacity-30 active:scale-95"
          >
            <LuChevronRight className="size-5" />
          </button>
        </div>
      }
    />
  );
}
